



























import BaseComponent from '@/components/base-component.vue';
import { listNPTs } from '@/services/therapy';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class UiRadioGroupsNPTs extends BaseComponent {
  @Prop()
  public value: any;

  @Prop({ default: 'Tipo' })
  public label?: string;

  @Prop({ default: false })
  public required?: boolean;

  @Prop({ default: false })
  public disabled?: boolean;

  @Prop({ default: true })
  public returnObject?: boolean;

  @Prop({ default: () => [] })
  private rules?: any[];

  loading = false;
  error = false;
  npt = null;
  items = [];
  NPT_EXCLUSIVA = 'E';

  mounted() {
    this.loadNPTs();
  }

  public onChange(val) {
    this.$emit('input', val);
    this.$emit('change', val);
  }

  private loadNPTs(): void {
    this.npt = null;
    this.loading = true;
    listNPTs().subscribe((res) => {
      this.items = res;
      this.loading = false;
      //this.npt = this.value;
      let val = this.items.filter((i) => i.id == this.NPT_EXCLUSIVA)[0];
      if (this.returnObject) {
        this.npt = val;
      } else {
        this.npt = val.id;
      }
      setTimeout(() => {
        this.onChange(this.npt);
      }, 300);
    });
  }

  public onLinkClick(link) {
    window.open(link, 'doclink');
  }
}
